import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface UseImageAltParams {
  rooms: number;
  area: number;
  description: string;
}

export const useImageAlt = ({
  rooms,
  area,
  description
}: UseImageAltParams): string => {
  const { t } = useTranslation();

  if (!rooms || !area) return '';

  return useMemo(() => {
    const roomsText = t('rooms.roominess', {
      count: rooms,
      postProcess: 'interval'
    });
    const areaText = t('area_metres', { area });

    return t('pages.residence.img_alt', {
      description,
      rooms: roomsText,
      area: areaText
    });
  }, [rooms, area, description]);
};
